
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
  computed: {
    isActive() {
      const currentUrl = window.location.href;
      return currentUrl.includes(this.url);
    },
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
});
